import { Box, IconButton, Popper, styled, Typography } from '@mui/material';
import { IconPartner } from 'assets/img';
import { useCallback, useState } from 'react';

export const CalendarShiftPartnersPopover = ({
  shiftId,
  shiftPartners,
}: {
  shiftId: string;
  shiftPartners?: { name: string; id: string }[];
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMouseEnter = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleClose = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setAnchorEl(null);
    },
    [setAnchorEl]
  );

  return (
    <Box pr={1}>
      <CandidateIconButton onMouseLeave={handleClose} onMouseEnter={handleMouseEnter}>
        <IconPartner />
      </CandidateIconButton>
      <Popper
        onMouseLeave={handleClose}
        id={shiftId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        placement="bottom-start"
      >
        <StyledBox>
          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
            Beschikbaar voor:
          </Typography>
          <Box display="flex" flexWrap="wrap" flexDirection="column" gap={1} paddingTop={3}>
            {shiftPartners
              ? shiftPartners.map(({ name }) => (
                  <Box key={name}>
                    <Typography variant="body2">{name}</Typography>
                  </Box>
                ))
              : null}
          </Box>
        </StyledBox>
      </Popper>
    </Box>
  );
};
const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  width: theme.spacing(40),
  minWidth: theme.spacing(40),
  border: '2px solid #00000019',
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
}));

<StyledBox sx={{ color: 'red' }}>{}</StyledBox>;

const CandidateIconButton = styled(IconButton)(({ theme }) => ({
  width: '30px',
  height: '35px',
  padding: theme.spacing(0.5),
  marginLeft: theme.spacing(1),
}));
